import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser } = useAuth();
    const processed = useRef(false);

    if (!processed.current) {
        processed.current = true;
    }

    useEffect(() => {
        const hash = location.hash || window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/callback", {
                    session_id: sessionId,
                });
                setUser(data);
                navigate("/admin", { replace: true, state: { user: data } });
            } catch (e) {
                navigate("/login?error=auth_failed", { replace: true });
            }
        })();
    }, [location.hash, navigate, setUser]);

    return (
        <div className="min-h-[100vh] electric-bg flex items-center justify-center">
            <div className="flex items-center gap-3 text-white/80">
                <Loader2 className="animate-spin text-[#00B7FF]" size={20} />
                <span className="text-xs uppercase tracking-[0.25em] font-semibold">
                    Verifying session…
                </span>
            </div>
        </div>
    );
}
